import { startListening } from '../listenerMiddleware';
import { deleteTimer } from '../slices/timersSlice';
import { getTimerWorkerInstance } from '../../../src/workers/timerWorkerInstance';

// Centralized config for timer-related actions and their delete logic
const TIMER_DELETE_CONFIG = [
    {
        type: 'gameTable/handleWatchTimerData', //gameTable is the name given in createSlice of the that redux script
        getTimerId: (action) => 'watch-timer-' + action.payload.tempTableId,
        shouldDelete: (action) => action.payload.timeLeft <= 0,
    },
];

/**
 * listenerApi:
 * In Redux Toolkit's listener middleware, listenerApi is an object provided to the effect function of a 
 * listener. It gives access to methods and information for interacting with the Redux store and 
 * dispatching actions.
 */

// Register the timer cleanup listener for timer state cleanup
// Use predicate to react to multiple actions or need custom logic to decide when to run the effect.
startListening({
    predicate: (action) => TIMER_DELETE_CONFIG.some(cfg => cfg.type === action.type),
    effect: async (action, listenerApi) => {
        const config = TIMER_DELETE_CONFIG.find(cfg => cfg.type === action.type);
        if (config && config.shouldDelete(action)) {
            console.log("DELETING TIMER FOR ACTION:", action.type, "Timer ID:", config.getTimerId(action));
            const timerId = config.getTimerId(action);
            listenerApi.dispatch(deleteTimer({ timerId }));
        }
    }
});

// Register the timer worker cleanup listener for deleteTimer
// Use actionCreator when you want to react to a single, specific action.
startListening({
    actionCreator: deleteTimer,
    effect: async (action, listenerApi) => {
        const { timerId } = action.payload;
        const timerWorker = getTimerWorkerInstance();
        timerWorker.postMessage({
            type: 'unsubscribe',
            timerId,
        });
        // Optionally, log for debugging
        console.log('Unsubscribed timer in worker (deleteTimer):', timerId);
    },
});
